export default function Social(){
    return(
        <div>Welcome to Social!</div>
    );
}